if (!customElements.get('header-announcement-ticker')) {
  customElements.define(
    'header-announcement-ticker',
    class HeaderAnnouncementTicker extends window.BAO.CustomElement {
      constructor () {
        super()

        this.items = [...this.querySelectorAll('.hd-AnnouncementBar_Item')]
        this.current = 0
        this.paused = false
        this.switching = false

        this.freeShippingAmount = this.dataset.free_shipping_amountEl
        this.currencySymbol = this.dataset.currencySymbolEl
        this.currencyCode = this.dataset.currencyCodeEl

        // Seconds each message stays on screen
        const seconds = parseFloat(this.dataset.intervalEl)
        this.interval = (seconds > 0 ? seconds : 5) * 1000

        if (this.freeShippingAmount != null) {
          this.currencyConversion()
        }

        this.items[0]?.classList.add('is-active')
        this.setHeight()
        window.addEventListener('resize', () => this.setHeight())

        // Messages swap in place, so only start rotating when there is more than one
        if (this.items.length > 1) {
          this.addEventListener('mouseenter', () => (this.paused = true))
          this.addEventListener('mouseleave', () => (this.paused = false))
          this.addEventListener('focusin', () => (this.paused = true))
          this.addEventListener('focusout', () => (this.paused = false))

          this.startTimer()
        }
      }

      disconnectedCallback () {
        clearInterval(this.timer)
        super.disconnectedCallback?.()
      }

      startTimer () {
        clearInterval(this.timer)
        this.timer = setInterval(() => {
          if (!this.paused && !document.hidden) this.goTo(this.current + 1)
        }, this.interval)
      }

      // Slide the current message up and out while the next one slides up into view
      goTo (index) {
        if (this.switching) return

        const next = (index + this.items.length) % this.items.length
        if (next === this.current) return

        this.switching = true

        const leaving = this.items[this.current]
        leaving.classList.remove('is-active')
        leaving.classList.add('is-leaving')

        this.current = next
        this.items[this.current].classList.add('is-active')

        // Once it has left, put it back below without animating
        setTimeout(() => {
          leaving.classList.add('is-resetting')
          leaving.classList.remove('is-leaving')
          void leaving.offsetWidth
          leaving.classList.remove('is-resetting')
          this.switching = false
        }, 400)
      }

      // All messages share one grid cell, so the bar is as tall as the tallest
      // message and the header offset never changes when messages switch.
      setHeight () {
        const body = document.body || document.documentElement
        body.style.setProperty(
          '--Announcement_Height',
          `${this.offsetHeight}px`,
        )
      }

      currencyConversion () {
        const localeFreeShippingCost = this.freeShippingAmount * window.Shopify.currency.rate
        const localeFreeShippingRounded = Math.ceil(localeFreeShippingCost.toFixed(2))
        const LocaleCurrencyMsg = `${this.currencySymbol}${localeFreeShippingRounded} `

        const replaceText = this.querySelectorAll('.shipping-amount')
        if (replaceText.length > 0) {
          replaceText.forEach((el) => {
            el.textContent = LocaleCurrencyMsg
            el.style.display = 'inline'
          })
        }
      }
    },
  )
}
